import React from 'react';
const IconActionBuild = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_29242_81877)">
<path fillRule="evenodd" clipRule="evenodd" d="M16.9583 5.08983L14.2598 7.64206L14.6023 9.42087L16.3811 9.76338L18.9574 7.03947L20.3748 5.54088C20.7778 6.12414 21.0954 6.77094 21.3095 7.4632C21.514 8.12417 21.624 8.82657 21.624 9.55469C21.624 13.459 18.459 16.624 14.5547 16.624C10.6504 16.624 7.48535 13.459 7.48535 9.55469C7.48535 5.6504 10.6504 2.48535 14.5547 2.48535C15.2335 2.48535 15.89 2.58103 16.5114 2.75964C17.2136 2.96149 17.8711 3.26926 18.4652 3.66454L16.9583 5.08983ZM17.8342 11.1377L19.6153 9.25447C19.6211 9.35376 19.624 9.45385 19.624 9.55469C19.624 12.3544 17.3544 14.624 14.5547 14.624C11.755 14.624 9.48535 12.3544 9.48535 9.55469C9.48535 6.75497 11.755 4.48535 14.5547 4.48535C14.5983 4.48535 14.6418 4.4859 14.6851 4.48699L12.8855 6.18903L12.0885 6.9429L12.2959 8.02022L12.6384 9.79903L12.8945 11.1288L14.2242 11.3848L16.003 11.7273L17.0803 11.9347L17.8342 11.1377ZM1.90137 20.7971L7.48358 15.2149L8.89778 16.6291L3.31557 22.2113L1.90137 20.7971Z" fill="#2D2E2E"/>
</g>
<defs>
<clipPath id="clip0_29242_81877">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

);
};
export default IconActionBuild;